module.exports = __webpack_public_path__ + "media/svg/ga-70dbf886.svg";